import { useState } from 'react';
import { ApiError } from './api';

/** Helper kecil: state submit + pesan galat dari API. */
export function useSubmit<T extends unknown[]>(fn: (...args: T) => Promise<void>) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  return {
    busy,
    error,
    clear: () => setError(null),
    run: async (...args: T) => {
      setBusy(true);
      setError(null);
      try {
        await fn(...args);
        return true;
      } catch (e) {
        setError(e instanceof ApiError ? e.message : 'Terjadi kesalahan jaringan');
        return false;
      } finally {
        setBusy(false);
      }
    },
  };
}
